exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reminder {\n    border: solid 1px #979797;\n    position: relative;\n    margin-bottom: 15px;\n}\n.reminder .highlighter {\n    width: 7px;\n    position: absolute;\n    background-color: #b8e986;\n    border-right: solid 1px #979797;\n    left: 0px;\n    bottom: 0;\n    top: 0;\n}\n.reminder .content {\n    padding: 0 20px;\n}\n.reminder .content .title {\n    font-size: 18px;\n    font-weight: 400;\n    color: #737373;\n    margin: 5px 0;\n    text-transform: capitalize;\n}\n.reminder .content .description {\n    font-size: 14px;\n    color: #c5c5c5;\n    margin: 5px 0;\n}\n\n", ""]);

// exports
